import { useEffect } from 'react';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { getImageSrc } from '../../../utils/assets';
import { useProgress, useTaskData } from '../../../hooks/task';
import { useTracker } from '../../../hooks/tracking';
import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';

/* @bend-expect no-styled-foundations-components */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledProgress = styled(Progress).withConfig({
  displayName: "AllTasksProgressBar__StyledProgress",
  componentId: "sc-1m1gq0n-0"
})(["height:20px;"]);
const ProgressBarText = ({
  selectedView
}) => {
  if (selectedView === ONBOARDING_VIEWS.SALES) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.sales"
    });
  } else if (selectedView === ONBOARDING_VIEWS.MARKETING) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.marketing"
    });
  } else if (selectedView === ONBOARDING_VIEWS.SERVICE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.service"
    });
  } else if (selectedView === ONBOARDING_VIEWS.CMS) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.cms"
    });
  } else if (selectedView === ONBOARDING_VIEWS.COMMERCE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.commerce"
    });
  }

  // fall back scenario
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.consolidatedUserGuide.progressIndicator.title.default"
  });
};
const AllTasksProgressBar = ({
  selectedView
}) => {
  const {
    hasErrored: errorLoadingTaskData
  } = useTaskData();
  const {
    progressRate
  } = useProgress();
  const {
    trackSectionView
  } = useTracker();
  useEffect(() => trackSectionView('all tasks progress bar', String(progressRate)), [trackSectionView, progressRate]);
  if (errorLoadingTaskData) {
    return null;
  }
  const viewIconSrc = getImageSrc(`icon/${selectedView}`, 'svg');
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "end",
    "data-test-id": "consolidated-progress",
    gap: "250",
    minInlineSize: "100%",
    children: [/*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(StyledProgress, {
        descriptiveLabel: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          marginBlockEnd: "200",
          minInlineSize: "100%",
          children: [viewIconSrc && /*#__PURE__*/_jsx(Image, {
            alt: selectedView,
            maxBlockSize: "24px",
            responsive: false,
            src: viewIconSrc
          }), /*#__PURE__*/_jsx(Text, {
            as: "h5",
            textWrap: "nowrap",
            children: /*#__PURE__*/_jsx(ProgressBarText, {
              selectedView: selectedView
            })
          })]
        }),
        marginBlockEnd: "0",
        use: "success",
        value: progressRate
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedPercentage, {
        value: progressRate
      })
    })]
  });
};
export default AllTasksProgressBar;